import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { Tooltip } from "../tooltip";
import { useConfig } from "../_util/config-context";
export var Icon = forwardRef(function (props, ref) {
    var classPrefix = useConfig().classPrefix;
    var _a = props.type, type = _a === void 0 ? "" : _a, size = props.size, className = props.className, tooltip = props.tooltip, link = props.link, htmlProps = __rest(props, ["type", "size", "className", "tooltip", "link"]);
    var iconClassName = classNames(className, classPrefix + "-icon", classPrefix + "-icon-" + type, {
        "size-s": size === "s",
        "size-l": size === "l",
    });
    var Parent = link ? "a" : "i";
    var label = type.replace("-blue", "").replace("-hover", "");
    var icon = (React.createElement(Parent, __assign({ ref: ref, className: iconClassName, role: "img", "aria-label": label }, htmlProps)));
    if (tooltip) {
        return React.createElement(Tooltip, { title: tooltip }, icon);
    }
    return icon;
});
Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map